export default __webpack_public_path__ + "static/media/151-paper-printer.433dd090.png";